import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './WhyChooseUs.css';
import IMG from '../asset/contact-comment.png';


const WhyChooseUs = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true,     // animate only once when in view
    });
  }, []);

  return (
    <section id="why-choose-us">
      <div className="why-choose-bottom" data-aos="fade-up">
        <div className="why-choose-heading Darkerr">
          <h1 >Why Choose Us</h1>
        </div>
      </div>

      <div className="why-choose-content">
        <div className="why-choose-image" data-aos="fade-right">
          <img src={IMG} alt="logo" />
        </div>

        <div className="why-choose-text poppins-semibold" data-aos="fade-left">
          <p>
            We provide the best services and solutions for your overseas education needs, ensuring a seamless<br />
            and successful journey. Our expert team offers comprehensive support, including visa processing,<br />
            application assistance, education loan guidance, and accommodation arrangements. With personalized<br />
            counseling, we help you choose the ideal country, program, and university that align with your goals.<br />
            We boast a strong network of partner universities and a high success rate, making the application<br />
            process smooth and stress-free. Our coaching for IELTS, TOEFL, and GMAT ensures you meet entry<br />
            requirements with confidence. From airport pickup to job assistance, we are dedicated to making your<br />
            study abroad experience exceptional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
